<template>
  <dorm-attendance-v3 mode="config" />
</template>

<script>
import DormAttendanceV3 from './DormAttendanceV3.vue'

export default {
  name: 'DormAttendanceConfig',
  components: { DormAttendanceV3 }
}
</script>
